import React from 'react';
import { Link } from 'react-router-dom';
import Header from 'components/Header/Header';
import styles from './MaintenancePage.module.scss';

class MaintenancePage extends React.PureComponent {
  render() {
    return (
      <div className={styles.pageWrapper}>
        <Header
          showNotifications={false}
          showProfileMenu={false}
          logout={() => {}}
        />
        <main className={styles.content}>
          <div className={styles.contentArea}>
            <img
              src="/images/maintenance.svg"
              alt="Illustration showing system maintenance in progress"
              className={styles.illustration}
              onError={(e) => {
                (e.target as HTMLImageElement).style.display = 'none';
              }}
            />
            <h1 className={styles.heading}>We're down for maintenance</h1>
            <p className={styles.subtitle}>
              We're making improvements to the service. Please try again later.
            </p>
            <Link to="/login" className={styles.tryAgainButton}>
              Back to login
            </Link>
          </div>
        </main>
      </div>
    );
  }
}

export default MaintenancePage;
